// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"5fbb9724","304":"c3b4dbff","430":"8c9e4303","441":"2c4e7c74","524":"40fd9270"}[chunkId] + ".chunk.js";
};